import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteConfig, navigation } from "../../data/mockData";
import { Phone, Menu, X } from "lucide-react";

const DesktopNav = ({ pathname }) => (
  <nav className="hidden lg:flex items-center gap-1">
    {navigation.map((item) => (
      <Link
        key={item.path}
        to={item.path}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
          pathname === item.path
            ? "text-[#3A7D44] bg-[#E8F5E9]"
            : "text-gray-700 hover:text-[#3A7D44] hover:bg-[#F1F8F2]"
        }`}
      >
        {item.label}
      </Link>
    ))}
  </nav>
);

const HeaderActions = () => (
  <div className="hidden lg:flex items-center gap-3">
    <a
      href={`tel:${siteConfig.phone}`}
      className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#3A7D44] border border-[#3A7D44] rounded-lg hover:bg-[#F1F8F2] transition-colors duration-200"
    >
      <Phone size={16} />
      {siteConfig.phoneFormatted}
    </a>
    <a
      href={siteConfig.calendlyUrl}
      
      
      className="px-5 py-2.5 text-sm font-semibold text-white bg-[#3A7D44] rounded-lg hover:bg-[#2D5A35] transition-colors duration-200 shadow-sm"
    >
      Get a Quote
    </a>
  </div>
);

const MobileMenu = ({ isOpen, pathname }) => (
  <div
    className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
      isOpen ? "max-h-96 opacity-100 mt-4" : "max-h-0 opacity-0"
    }`}
  >
    <nav className="flex flex-col gap-1 pb-4 border-t border-gray-100 pt-4">
      {navigation.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
            pathname === item.path
              ? "text-[#3A7D44] bg-[#E8F5E9]"
              : "text-gray-700 hover:text-[#3A7D44] hover:bg-[#F1F8F2]"
          }`}
        >
          {item.label}
        </Link>
      ))}
      <div className="flex flex-col gap-2 mt-3 pt-3 border-t border-gray-100">
        <a
          href={`tel:${siteConfig.phone}`}
          className="flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-[#3A7D44] border border-[#3A7D44] rounded-lg"
        >
          <Phone size={16} />
          {siteConfig.phoneFormatted}
        </a>
        <a
          href={siteConfig.calendlyUrl}
          
          
          className="text-center px-4 py-3 text-sm font-semibold text-white bg-[#3A7D44] rounded-lg"
        >
          Get a Quote
        </a>
      </div>
    </nav>
  </div>
);

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white/95 backdrop-blur-md shadow-md py-2"
          : "bg-white py-3"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 flex-shrink-0">
            <img
              src={siteConfig.logo}
              alt="Hess Insurance Solutions"
              className="h-12 sm:h-14 w-auto"
            />
          </Link>

          <DesktopNav pathname={location.pathname} />
          <HeaderActions />

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        <MobileMenu isOpen={isMobileMenuOpen} pathname={location.pathname} />
      </div>
    </header>
  );
};

export default Header;
